import { Link, useParams } from "react-router-dom";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ComicCard from "@/components/feature/ComicCard";
import EmptyState from "@/components/feature/EmptyState";
import { getAuthorById, getComicsByAuthor } from "@/utils/comic";

export default function AuthorPage() {
  const { authorId } = useParams();
  const author = getAuthorById(authorId);
  const works = author ? getComicsByAuthor(author.id) : [];

  if (!author || works.length === 0) {
    return (
      <div className="w-full px-4 md:px-6 pt-24 md:pt-28 pb-16">
        <EmptyState
          icon="ri-user-unfollow-line"
          title="暂无作者信息或作品数据"
          description="这位作者的主页还在建设中，先去看看其他作者和他们笔下的故事吧。"
          action={
            <Link
              to="/"
              className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-label font-bold"
            >
              返回首页
            </Link>
          }
        />
      </div>
    );
  }

  return (
    <div className="w-full">
      <section className="w-full px-4 md:px-6 pt-24 md:pt-28 pb-10 bg-background-100">
        <Breadcrumb
          items={[
            { label: "首页", to: "/" },
            { label: "作者合集", to: "/" },
            { label: author.name },
          ]}
        />

        <div className="mt-6 flex flex-col md:flex-row gap-6 md:gap-8">
          <div className="w-28 h-28 md:w-36 md:h-36 shrink-0 rounded-lg overflow-hidden bg-background-200 mx-auto md:mx-0">
            <img
              src={author.avatar}
              alt={`${author.name} 作者头像`}
              title={`${author.name} - 蛙漫签约作者`}
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="flex-1 min-w-0 text-center md:text-left">
            <h1 className="text-2xl md:text-3xl font-label font-bold text-foreground-950">
              {author.name}
            </h1>
            <div className="mt-2 flex flex-wrap items-center justify-center md:justify-start gap-2 text-xs">
              <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 font-label font-bold">
                {author.style}
              </span>
              <span className="px-2.5 py-1 rounded-full bg-background-200 text-foreground-700">
                <i className="ri-map-pin-line mr-1"></i>
                {author.location}
              </span>
              <span className="px-2.5 py-1 rounded-full bg-background-200 text-foreground-700">
                <i className="ri-user-heart-line mr-1"></i>
                {author.followers} 关注
              </span>
              <span className="px-2.5 py-1 rounded-full bg-background-200 text-foreground-700">
                <i className="ri-book-2-line mr-1"></i>
                {works.length} 部作品
              </span>
            </div>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              {author.bio}
            </p>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10">
        <div className="flex items-end justify-between gap-4 mb-5">
          <h2 className="text-lg md:text-xl font-label font-bold text-foreground-950">
            全部作品
          </h2>
          <Link
            to="/"
            className="text-xs md:text-sm font-label font-bold text-primary-600 hover:text-primary-700 whitespace-nowrap"
          >
            <i className="ri-arrow-left-line mr-1"></i>
            返回首页
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
          {works.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </section>
    </div>
  );
}